import { lazy, Suspense } from 'react'
import { Outlet, RouteObject } from 'react-router'
import { SuspenseLoading } from '@/common/components/SuspenseLoading.tsx'
import {
  PromotionNominationDetailsProvider,
} from '@/pages/promotion/promotion-details/usePromotionNominationDetails.ts'
import { ManagerRoutes } from '@/common/layouts/ManagerRoutes.tsx'

const PromotionListPage = lazy(() => import('@/pages/promotion/promotion-list/promotion-list-page.tsx'))
const PromotionDetailsPage = lazy(() => import('@/pages/promotion/promotion-details/promotion-details-page.tsx'))

export const promotionRoutes: RouteObject = {
  path: 'promotion',
  element: <Outlet />,
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<SuspenseLoading />}>
          <ManagerRoutes>
            <PromotionListPage />
          </ManagerRoutes>
        </Suspense>
      ),
    },
    {
      path: ':promotionNominationId',
      element: <Suspense fallback={<SuspenseLoading />}>
        <PromotionNominationDetailsProvider>
          <PromotionDetailsPage />
        </PromotionNominationDetailsProvider>
      </Suspense>,
    },
  ],
}
